import React from 'react';
import {
    Route,
    RouterProvider,
    createBrowserRouter,
    createRoutesFromElements
} from 'react-router-dom';

import FleetManagement from '../pages/FleetManagement';
import OrganizationMemberDetails from '../pages/FleetManagement/OrganizationMemberDetails';
import AdherenceModule from '../pages/FleetManagement/OrganizationMemberDetails/AdherenceModule';
import OverviewModule from '../pages/FleetManagement/OrganizationMemberDetails/Overview';
import CaregivingInfo from '../pages/FleetManagement/OrganizationMemberDetails/CaregivingInfo';
import EhrRecord from '../pages/FleetManagement/OrganizationMemberDetails/EhrRecord';
import HistoryLogModule from '../pages/FleetManagement/OrganizationMemberDetails/HistoryLogModule';
import MedicationInfo from '../pages/FleetManagement/OrganizationMemberDetails/MedicationInfo';
import Home from '../pages/Home';
import LeadsManagement from '../pages/LeadsManagement';
import UsersManagement from '../pages/UsersManagement';
import ProtectedRoute from './ProtectedRoute';
// import LeadDetails from '../pages/LeadsManagement/Details';
import PageNotFound from '../components/PageNotFound';
import { showMemberActivityFeature } from '../constants/featureFlags';
import { useUserPolicyContext } from '../context/UserPolicy';
import PatientActivity from '../pages/FleetManagement/OrganizationMemberDetails/PatientActivity';
import LeadDetailsV2 from '../pages/LeadsManagement/Details/v2';
import OurPerformance from '../pages/OurPerformance';
import ReportsManagement from '../pages/ReportsManagement';
import MonthlyCare from '../pages/MonthlyCare';
import useShowMonthlyCare from '../pages/MonthlyCare/useShowMonthlyCare';

const AppRoutes: React.FC = () => {
    const { orgProperties } = useUserPolicyContext();
    const showMonthlyCare = useShowMonthlyCare();

    const router = createBrowserRouter(
        createRoutesFromElements(
            <>
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Home />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/members"
                    element={
                        <ProtectedRoute>
                            <FleetManagement />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/members/:id"
                    element={
                        <ProtectedRoute>
                            <OverviewModule />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/members/:id/demographics"
                    element={
                        <ProtectedRoute>
                            <OrganizationMemberDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/members/:id/medications"
                    element={
                        <ProtectedRoute>
                            <MedicationInfo />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/members/:id/caregiving"
                    element={
                        <ProtectedRoute>
                            <CaregivingInfo />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/members/:id/adherence"
                    element={
                        <ProtectedRoute>
                            <AdherenceModule />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/members/:id/ehr"
                    element={
                        <ProtectedRoute>
                            <EhrRecord />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/members/:id/activity"
                    element={
                        <ProtectedRoute>
                            {showMemberActivityFeature ? <PatientActivity /> : <PageNotFound />}
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/members/:id/log"
                    element={
                        <ProtectedRoute>
                            <HistoryLogModule />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/form-fills"
                    element={
                        <ProtectedRoute>
                            <LeadsManagement />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/form-fills/:id"
                    element={
                        <ProtectedRoute>
                            <LeadDetailsV2 />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/users"
                    element={
                        <ProtectedRoute>
                            <UsersManagement />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/reports"
                    element={
                        <ProtectedRoute>
                            {orgProperties?.has_device_activity_report ? (
                                <ReportsManagement />
                            ) : (
                                <PageNotFound />
                            )}
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/monthly-care"
                    element={
                        <ProtectedRoute>
                            {showMonthlyCare ? <MonthlyCare /> : <PageNotFound />}
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/our-performance"
                    element={
                        <ProtectedRoute>
                            <OurPerformance />
                        </ProtectedRoute>
                    }
                />
                <Route path="*" element={<PageNotFound />} />
            </>
        )
    );

    return <RouterProvider router={router} />;
};

export default AppRoutes;
